export default __webpack_public_path__ + "1a5aaf05b05556f0cac08e4ac297c7b1.png";